/**
* スライダーのコンストラクタ
* @constructor
* @param {selector} el - セレクタ
* @param {options} object - オプション
*/
module.exports = Slider = function(el, options){
  this.element = $(el);
  this.breakpoint = options.bp;
  this.media = this.element.data('media');
  this.type = this.element.data('type');
  switch (this.type) {
    case 'bnr':
      this.sliderSettings = {
        centerMode: true,
        slidesToShow: 1,
        accessibility: false,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        slide: 'a',
        variableWidth: true,
        pauseOnHover: false
      };
      break;
    case 'mv':
      this.sliderSettings = {
        centerMode: true,
        slidesToShow: 1,
        accessibility: false,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        slide: 'div',
        variableWidth: true,
        dots: true,
        centerPadding: '0',
        fade: true,
        arrows: false,
        draggable: false,
        touchMove: false,
        pauseOnHover: false
      };
      break;
    default:
      this.sliderSettings = {};
  }
  this.win = $(window);
  this.init();
};

/**
* init
*/
Slider.prototype.init = function(){
  var self = this;
  self.onResize();// どのみち一度は走るので

  if (self.media !== undefined) {
    var timer = false;
    self.win.on('resize', function() {
      if (timer !== false) {
        clearTimeout(timer);
      }
      timer = setTimeout(function() {
        // console.log('resized');
        self.onResize();
      }, 200);
    });
  }
};

/**
* event
*/
Slider.prototype.event = function(param){
  var self = this;
  var options = (param === true) ? self.sliderSettings : 'unslick';
  // console.log(self.element);
  self.element.slick(options);
};

/**
* resize
*/
Slider.prototype.onResize = function(){
  var self = this;

  var w = self.win.width();
  var isEnabledVP;
  switch (self.media) {
    case 'pc':
      isEnabledVP = (w >= self.breakpoint);
      break;
    case 'sp':
      isEnabledVP = (w < self.breakpoint);
      break;
    default:
      isEnabledVP = true;// サイズにかかわらず有効の意
  }

  if (isEnabledVP && self.enabled !== true) {
    self.event(true);
    self.enabled = true;
  } else if (!isEnabledVP && self.enabled === true) {
    self.event(false);
    self.enabled = false;
  }
};



//////////////////
// WEBPACK FOOTER
// ./js/_modules/slider.js
// module id = 3
// module chunks = 0